import { render, staticRenderFns } from "./StandardCheckout.vue?vue&type=template&id=0f5d7caa&scoped=true&"
import script from "./StandardCheckout.vue?vue&type=script&lang=js&"
export * from "./StandardCheckout.vue?vue&type=script&lang=js&"
import style0 from "./StandardCheckout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StandardCheckout.vue?vue&type=style&index=1&id=0f5d7caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d7caa",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports